import React from 'react';
import { Text } from '@tamagui/core';
import { XStack } from '@tamagui/stacks';
import { CheckCheck } from 'lucide-react-native';
import { COLORS } from '@/constants/colors';
import { ICON_SIZE_SMALL } from '../constants';

type TagProps = {
  text: string;
  checked?: boolean;
  isDark?: boolean;
};

const Tag = React.memo<TagProps>(({ text, checked, isDark }) => {
  const bgColor = isDark ? COLORS.GRAY_700 : COLORS.TRANSPARENT;
  const textColor = isDark ? COLORS.WHITE : COLORS.GRAY_900;
  const checkedTextColor = isDark ? COLORS.PINK : COLORS.PINK;
  const checkedBorderColor = isDark ? COLORS.PINK : COLORS.PINK;
  const borderColor = isDark ? COLORS.GRAY_400 : COLORS.GRAY_400;

  
  return (
    <XStack 
      alignItems="center" 
      gap="$2" 
      paddingHorizontal="$3" 
      paddingVertical="$2" 
      borderRadius="$3" 
      backgroundColor={bgColor}
      borderWidth={1}
      borderColor={checked ? checkedBorderColor : borderColor}
    >
      {checked ? <CheckCheck size={ICON_SIZE_SMALL} color={checkedTextColor} /> : null}
      <Text color={checked ? checkedTextColor : textColor} fontWeight="700">{text}</Text>
    </XStack>
  );
});

Tag.displayName = 'Tag';

export default Tag;

